<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_HistoryDetails')"
    width="700px"
    append-to-body
    :close-on-click-modal="false"
  >
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width:100%;height:300px"
      @gridReady="params=>gridApi=params.api"
    />
  </el-dialog>
</template>

<script>

import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'TaskLogDetailDialog',
  props: {
    visible: { type: Boolean, required: true },
    rowData: { type: Array, required: false, default: () => [] }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_DataID'),
          field: 'sourceId',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ExecutionScenario'),
          field: 'name',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ExecuteCommandName'),
          field: 'commandName',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.TASK_SCENARIO_LIST)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ExecutionTime'),
          field: 'dateCreated',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ExecuteResult'),
          field: 'executionResult',
          width: 200,
          cellRenderer: params => {
            if (String(params.value) === '1') {
              return this.$t('CargoMsg.Cargo_Success')
            }
            return this.$t('Message.Failure') + ':' + params.data.executionMessage
          },
          tooltipValueGetter: (params) => {
            if (String(params.value) === '1') {
              return this.$t('CargoMsg.Cargo_Success')
            }
            return this.$t('Message.Failure') + ':' + params.data.executionMessage
          }
        }
      ],
      gridApi: null
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  }
}
</script>

<style>
</style>
